module.exports = __webpack_public_path__ + "static/media/notfavorite.10acf8e5.svg";